import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Typography,
    Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Icon } from '@iconify/react/dist/iconify.js';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteConfirmModal = ({
    open,
    handleClose,
    handleConfirm,
    title = 'Delete Item',
    itemName = '',
    itemId = '',
    isLoading = false,
}) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: 'hidden',
                }
            }}
        >
            {/* Header */}
            <DialogTitle sx={{ p: 0 }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 2.5,
                        py: 2,
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', fontSize: '1rem' }}>
                        {title}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        size="small"
                        sx={{
                            color: 'text.secondary',
                            '&:hover': {
                                backgroundColor: 'action.hover',
                            },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
            </DialogTitle>

            {/* Content */}
            <DialogContent sx={{ p: 0 }}>
                <Box sx={{ px: 2.5, py: 4, textAlign: 'center' }}>
                    {/* Warning Icon */}
                    <Box
                        sx={{
                            width: 80,
                            height: 80,
                            borderRadius: '50%',
                            backgroundColor: '#fef2f2',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto',
                            mb: 3,
                        }}
                    >
                        <Icon
                            icon="solar:trash-bin-trash-bold"
                            width={40}
                            height={40}
                            style={{ color: '#ef4444' }}
                        />
                    </Box>

                    {/* Message */}
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'text.primary',
                            fontWeight: 500,
                            mb: 1,
                            fontSize: '1rem',
                        }}
                    >
                        Are you sure you want to delete?
                    </Typography>

                    {/* Item Details */}
                    {(itemName || itemId) && (
                        <Box
                            sx={{
                                backgroundColor: '#f8fafc',
                                borderRadius: 2,
                                px: 2,
                                py: 1.5,
                                mt: 2,
                                border: '1px solid',
                                borderColor: 'divider',
                            }}
                        >
                            {itemName && (
                                <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 600, color: 'text.primary' }}
                                >
                                    {itemName}
                                </Typography>
                            )}
                            {itemId && (
                                <Typography
                                    variant="caption"
                                    sx={{ color: 'text.secondary' }}
                                >
                                    ID: {itemId}
                                </Typography>
                            )}
                        </Box>
                    )}

                    {/* Warning Text */}
                    <Typography
                        variant="caption"
                        sx={{
                            color: 'text.secondary',
                            display: 'block',
                            mt: 2,
                        }}
                    >
                        This action cannot be undone. All associated data will be permanently removed.
                    </Typography>
                </Box>
            </DialogContent>

            {/* Actions */}
            <DialogActions sx={{ px: 2.5, py: 2, borderTop: '1px solid', borderColor: 'divider', gap: 1.5 }}>
                {console.log(isLoading, 'deleteloader')}
                <button
                    type="button"
                    className="btn btn-outline-secondary radius-8 px-20 py-10 text-sm fw-medium"
                    onClick={handleClose}
                    disabled={isLoading}
                    style={{ flex: 1 }}
                >
                    <Icon icon="solar:close-circle-outline" className="me-6" />
                    No, Cancel
                </button>
                <button
                    type="button"
                    className="btn btn-danger radius-8 px-20 py-10 text-sm fw-medium"
                    onClick={handleConfirm}
                    disabled={isLoading}
                    style={{ flex: 1, backgroundColor: '#ef4444', borderColor: '#ef4444' }}
                >
                    {isLoading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-8" role="status" aria-hidden="true"></span>
                            Deleting...
                        </>
                    ) : (
                        <>
                            <Icon icon="solar:trash-bin-trash-bold" className="me-6" />
                            Yes, Delete
                        </>
                    )}
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmModal;
